"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.create.success': 'Datos de ranura creados exitosamente',
    'slotData.create.error': 'Error al crear datos de ranura',
};
